import useSWR from 'swr';
import fetcher from 'lib/fetcher';
import { TUserRole } from 'api/types';

export interface IUserFavorite {
  fullname: { firstName: string | null; lastName: string | null; patronymic: string | null };
  id: number;
  phone: string;
  type: TUserRole;
}

export type FavoriteListItem = {
  author: IUserFavorite;
  clients: IUserFavorite[];
  owners: IUserFavorite[];
  facilityCount: number;
  id: number;
  title: string;
  updatedAt: string;
  createdAt: string;
};

const useFavoriteListItem = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<FavoriteListItem>(
    `/favourites/list/${id}`,
    fetcher.swr,
    {
      errorRetryCount: 0,
      revalidateOnFocus: false,
    },
  );
  return { listItem: data ?? [], error, isLoading, mutate };
};

export default useFavoriteListItem;
